import { defineMessages } from 'react-intl';

export const messages: {
	connectorShowcaseEyebrow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectorShowcaseTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	browseConnectorsButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	browseConnectorsAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	connectorShowcaseEyebrow: {
		id: 'twg-microsite.connectorShowcase.eyebrow.non-final',
		defaultMessage: 'Integrations',
		description:
			'Small eyebrow label displayed above the title in the connector showcase section',
	},
	connectorShowcaseTitle: {
		id: 'twg-microsite.connectorShowcase.title.non-final',
		defaultMessage: '100+ connectors and counting',
		description: 'Title displayed above the connector icons carousel in the showcase section',
	},
	browseConnectorsButton: {
		id: 'twg-microsite.connectorShowcase.browseConnectorsButton.non-final',
		defaultMessage: 'Browse connectors',
		description: 'Button label to browse all available connectors',
	},
	browseConnectorsAriaLabel: {
		id: 'twg-microsite.connectorShowcase.browseConnectorsAriaLabel.non-final',
		defaultMessage: 'Browse connectors',
		description: 'Accessible label for the browse connectors button',
	},
});
